export const { createRoot } = WPTB.modules.ReactDOMClient;
